// types
import type { Duty, DutyHourType } from 'RestAPIs/cost-centers/employees/types';
import type {
  DutyHourType as OpenRequestDutyHourType,
  DutyRequestItem
} from 'RestAPIs/roster/open-requests/types';

/**
 * The duty hour types behind a set of duties, one entry per period.
 *
 * Rostered duties and open requests come from two endpoints with their own `DutyHourType` shape,
 * and both filter groups read the same `code` / `id` pair out of them — hence the union rather than
 * two near identical helpers. Duplicates are kept: `getUniqueFilterValues` is what dedupes.
 */
export const getAllDutyHourTypes = (
  data?: Duty[] | DutyRequestItem[]
): (DutyHourType | OpenRequestDutyHourType)[] =>
  ((data ?? []) as (Duty | DutyRequestItem)[])
    .map((duty) => duty?.periods ?? [])
    .flat()
    .map((period) => period?.dutyHourType)
    // `!= null`, not `!== undefined`: this is an asserted type predicate, so a null would be
    // narrowed to a non-null type and crash later on `dutyHourType['code']`
    .filter(
      (dutyHourType): dutyHourType is DutyHourType | OpenRequestDutyHourType =>
        dutyHourType != null
    );
